<template>
    <div class= "viewfull">
        <v-row class="viewfull">
            <v-col class="pb-0" cols="12" sm="12" md="4" lg="3">
              <div :style="showLine">
                <LeftDadosCadastrais ref="left" @changeButton="changeIndex" :index="index"/>
              </div>
            </v-col>
            <v-col cols="12" sm="12" md="8" lg="9" :class="$vuetify.breakpoint.xs ? 'pt-0 pb-10': 'pb-10'" :style="index === 2 ? { 'overflow': 'auto hidden' } : {}">
              <RightDadosCadastrais style="height: 100%" ref="right" :index="index" @changeIndex="changeIndex" @complete="complete" />
            </v-col>

        </v-row>
      <error-modal @input="closeError" v-model="showError" :errObj="errObj"/>
      <overlay-loading v-model="loading"/>
    </div>
</template>

<script>
import RightDadosCadastrais from './Shared/RightDadosCadastrais'
import LeftDadosCadastrais from './Shared/LeftDadosCadastrais'
import { EventBus } from '@/services/EventBus/EventBus'

export default {
  components: {
    RightDadosCadastrais,
    LeftDadosCadastrais
  },
  data () {
    return {
      opcaoEditar: localStorage.getItem('optionEdit'),
      index: 0,
      linhaVertical: {
        'border-right': '1px solid #DEE2E6',
        'height': '100%'
      },
      showError: false,
      errObj: {
        status: 'Status',
        error: 'Error'
      },
      showSuccess: false,
      loading: false
    }
  },
  beforeMount () {
    EventBus.$emit('changeIndexDados', this.index)
  },
  methods: {
    closeError () {
      this.showError = false
      this.$router.push('/home')
    },
    complete () {
      this.$refs.left.changeDisabled()
    },
    saveVersao () {
      this.$refs.right.salvarVersao()
    },
    backStep () {
      if (this.index >= 0) {
        this.index--
      }
    },
    async validarMudanca () {
      this.loading = true
      let res = await this.$refs.right.validarMudanca()
      this.loading = false
      return res
    },
    async validarDados () {
      this.loading = true
      let res = await this.$refs.right.salvarVersao()
      this.loading = false
      return res
    },
    async changeIndex (index) {
      this.loading = true
      let res = await this.$refs.right.salvarVersao()
      this.loading = false

      if (res) {
        this.index = index
      }

      EventBus.$emit('changeIndexDados', index)
    }

  },
  computed: {
    showLine () {
      return !(this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm) ? this.linhaVertical : ''
    }
  },
  watch: {
    index () {
      if (this.index === 0 || this.index === 1) {
        this.$emit('cancelar', true)
      } else {
        this.$emit('cancelar', false)
      }
    }
  }
}
</script>

<style lang="sass" scoped>
.linha
    border-top: 1px solid #DEE2E6
    width: 98%
    margin: 5px 0

.viewfull
  display: flex !important
  flex: 1 !important

</style>

